import script from "./ComicSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./ComicSearch.vue?vue&type=script&setup=true&lang=js"

import "@/features/comic/styles/ComicSearch.css?vue&type=style&index=0&id=7a9ec882&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a9ec882"]])

export default __exports__